module.exports = __webpack_public_path__ + "img/forklane-favicon.45f9ff43.png";